import React from "react";
import { node } from "prop-types";

import * as S from "./styled";

const HeaderNavButton = ({ children, ...props }) => (
  <S.HeaderNavButton {...props}>{children}</S.HeaderNavButton>
);

HeaderNavButton.propTypes = {
  children: node.isRequired
};

export default HeaderNavButton;
